import axios from 'axios';

const BASE_URL = 'https://redspeedapidev.redstarplc.com/api'

export default axios.create({
    baseURL: BASE_URL,
});